export default "__VITE_ASSET__CcUiMLka__"